import { eventArchive } from "@/mocks/homeData";
import SectionHead from "./SectionHead";

export default function EventArchive() {
  return (
    <section id="dangan" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <SectionHead
          kicker="档案式深度复盘"
          title="事件档案库 · 来龙去脉"
          desc="每条档案都从热搜炸开那一刻开始记录，按时间线摊开发酵、回应、反转的完整脉络。不是标题党，是愿意陪你慢下来读的一份存档。"
          action="浏览全部档案"
        />

        <div className="mt-10 space-y-10 md:mt-12 md:space-y-12">
          {eventArchive.map((ev, i) => {
            const flip = i % 2 === 1;
            return (
              <article
                key={ev.title}
                className="grid items-center gap-6 rounded-xl border border-background-200 bg-background-100 p-4 md:grid-cols-2 md:gap-8 md:p-6"
              >
                <a href="#" className={`block overflow-hidden rounded-lg md:order-none ${flip ? "md:order-2" : ""}`}>
                  <img
                    src={ev.image}
                    alt={ev.title}
                    title={`${ev.title} - 嘿料吃瓜档案`}
                    className="h-56 w-full object-cover object-top transition-transform duration-500 hover:scale-[1.03] md:h-72"
                  />
                </a>
                <div className={`flex flex-col gap-3 md:order-none ${flip ? "md:order-1 md:items-end md:text-right" : ""}`}>
                  <div className={`flex flex-wrap items-center gap-2 ${flip ? "md:justify-end" : ""}`}>
                    <span className="font-display text-sm font-bold tracking-widest text-accent-700">{ev.date}</span>
                    <span
                      className={`rounded px-2 py-0.5 text-xs font-bold ${
                        ev.tag === "正在发酵"
                          ? "bg-primary-100 text-primary-700"
                          : ev.tag === "追踪中"
                            ? "bg-accent-100 text-accent-800"
                            : "bg-secondary-200 text-secondary-900"
                      }`}
                    >
                      {ev.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-lg font-black leading-snug text-foreground-950 md:text-2xl">
                    <a href="#" className="hover:text-primary-600">
                      {ev.title}
                    </a>
                  </h3>
                  <p className="text-sm leading-relaxed text-foreground-600">{ev.synopsis}</p>
                  <div className={`mt-1 flex flex-wrap gap-2 ${flip ? "md:justify-end" : ""}`}>
                    {ev.steps.map((s, si) => (
                      <span key={s} className="flex items-center gap-1.5 rounded-full bg-background-50 px-3 py-1 text-xs text-foreground-700 ring-1 ring-background-200">
                        <span className="font-display font-bold text-primary-600">{si + 1}</span>
                        {s}
                      </span>
                    ))}
                  </div>
                  <div className={`mt-1 flex flex-wrap items-center gap-4 text-xs text-foreground-500 ${flip ? "md:justify-end" : ""}`}>
                    <span className="inline-flex items-center gap-1.5">
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-eye-line" />
                      </span>
                      {ev.reads} 人读过
                    </span>
                    <a href="#" className="inline-flex items-center gap-1 whitespace-nowrap font-bold text-primary-600 hover:text-primary-700">
                      阅读完整复盘
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-arrow-right-s-line" />
                      </span>
                    </a>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}